import {Order} from './order.model';
import {ListModel} from '../../shared/models/list.model';
import {Utilities} from '../../shared/utilities/utilities.model';

export class Orders extends ListModel {

	constructor(model?: any) {
		super(model);
		this.items = [];
		if (!Utilities.isVoid(model) && !Utilities.isVoid(model.items)) {
			model.items.forEach((order) => this.items.push(new Order(order)));
		}
	}
}
